import React from "react";
import Headline from "./Headline";
import Paragraph from "./Paragraph";
import {Colors} from "../Types";

const ImageAndTextDivider: React.FC<Props> = (
  {
    background,
    image,
    header,
    subHeader,
    texts,
    children,
    revertOrder= false,
    headerTextColor
  }
) => {
  const imageOrder = revertOrder ? '2xl:flex-row-reverse flex-row' : '2xl:flex-row';
  return(
    <div className={`flex items-center ${imageOrder} flex-col justify-center bg-${background} 2xl:gap-0 gap-6 py-12`}>
      <div className={`2xl:w-[50vw] w-[100vw] 2xl:min-h-[50vh] min-h-[50vh]`}>
        {/* Centred on mobile, left-aligned next to the image on desktop; text keeps the same measure everywhere */}
        <div className="flex flex-col 2xl:px-24 2xl:pt-24 pt-6 px-8 items-center 2xl:items-start gap-6">
          <Headline size="h2" color={headerTextColor} textAlign="text-center 2xl:text-left">{header}</Headline>
          <div className="w-[120px] h-px bg-white/75"/>
          <Headline size="h3" color="tertiary" textAlign="text-center 2xl:text-left">{subHeader}</Headline>
          <div className="flex flex-col max-w-[300px] 2xl:max-w-[560px] gap-3">
            {texts.map((text, index)=>{return <Paragraph key={index} color="text-white" textAlign="text-center 2xl:text-left" size="text-[15px] 2xl:text-base leading-[1.65]">{text}</Paragraph>})}
          </div>
          {children}
        </div>
      </div>
      <div className={`bg-image ${image} 2xl:w-[50vw] w-[100vw] 2xl:h-[50vh] h-[50vh]`}></div>
    </div>
  )
};

export default ImageAndTextDivider;

interface Props {
  background: string,
  image: string,
  header:string,
  subHeader:string,
  texts:string[],
  children?: React.ReactNode,
  revertOrder?: boolean;
  headerTextColor:Colors;
}